<shared-ui-modal-base-modal
  [cancelButtonTitle]="'button-close' | translate"
  [confirmButtonTitle]="'button-save' | translate"
  [title]="'modal-change-profile-title' | translate"
  (confirmOutput)="onSaveClick()"
>
  <div>
    <shared-ui-inputs-toggle-switch-group
      [display]="inputFieldDisplay"
      [name]="'customer-settings-clear-filters-on-logout' | translate"
      [parentFormGroup]="parentFormGroup"
      [id]="'changeProfileDialog'"
      [formName]="'toggleChangeProfileForm'"
    ></shared-ui-inputs-toggle-switch-group>
  </div>
</shared-ui-modal-base-modal>
